<template>
  <div class="mb-4 mt-3">
    <Loading v-if="loading.mcu" />
    <Empty v-else-if="listPertanyaan.length === 0" :message="'Saat ini belum ada hasil untuk ditampilkan.'"/>
    <div v-else class="">
      <div v-for="pertanyaan in listPertanyaan" :key="pertanyaan.id_pertanyaan" class="px-0 mb-3">
        <span class="fs-18 fw-700 color-neutral-900 mb-3">{{ pertanyaan.pertanyaan ?? 'Covid-19 Status:' }}</span>
        <div v-for="jawaban in pertanyaan.jawaban" :key="jawaban.id_jawaban" class="w-100 my-2 px-0">
          <!-- Ini Checkbox -->
          <div v-if="jawaban.format === 'checkbox'"
            class="card-info p-3 d-flex flex-row align-items-center border-0 justify-content-between"
            :class="{'bg-primary-50':jawabanUser[jawaban.name], 'bg-neutral-100':!jawabanUser[jawaban.name]}"
          >
            <label v-if="jawaban.format === 'checkbox'" class="form-check-label fs-12 fw-400 pe-3"
              :class="{'color-primary-500':jawabanUser[jawaban.name], 'color-neutral-900':!jawabanUser[jawaban.name]}">
              {{ jawaban.label }}
            </label>

            <input
              class="cursor-pointer"
              :type="formatType(jawaban.format)"
              :class="{
                'form-check-input':(jawaban.format === 'checkbox'),
                'form-control':!(jawaban.format === 'checkbox')
              }"
              :name="jawaban.name"
              :value="jawaban.label"
              v-model="jawabanUser[jawaban.name]"
              disabled
            >
          </div>

          <!-- Ini Text -->
          <div v-else-if="jawaban.format === 'text'">
            <input class="form-control form-capsule" type="text" :placeholder="jawaban.label" :name="jawaban.name" v-model="jawabanUser[jawaban.name]" disabled>
          </div>

          <!-- Ini Combo Box -->
          <div v-else-if="jawaban.format === 'combobox'" class="col">
            <span class="fs-14 fw-600 color-neutral-600 mb-3">{{ jawaban.label }}</span>
            <select :name="jawaban.name" v-model="jawabanUser[jawaban.name]" class="form-select form-capsule" disabled>
              <option v-for="comboVal in jawaban.combo_val" :key="comboVal.value" :value="comboVal.value">
                {{ comboVal.label }}
              </option>
            </select>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Loading from '@/components/utility/Loading'
import Empty from '@/components/utility/Empty'
import { onMounted, ref } from 'vue'
import { getPertanyaan, loading, mcu, submitPertanyaan } from '@/core/mcu'
import { user, token } from '@/core/auth'
import { DataURIToBlob, showNotif } from '@/core/utility'

export default {
  components: { Loading, Empty },
  setup () {
    const listPertanyaan = ref([])
    const jawabanUser = ref({})
    const ttdUser = ref(null)
    const testTtd = ref('')

    const formatType = (type) => {
      if (type === 'radiobutton') {
        return 'radio'
      }

      return type
    }

    const updateRadio = (pertanyaan, jawaban) => {
      for (let i = 0; i < listPertanyaan.value.length; i++) {
        if (listPertanyaan.value[i].name === pertanyaan) {
          for (let j = 0; j < listPertanyaan.value[i].jawaban.length; j++) {
            if (listPertanyaan.value[i].jawaban[j].name === jawaban) {
              jawabanUser.value[listPertanyaan.value[i].jawaban[j].name] = true
            } else {
              jawabanUser.value[listPertanyaan.value[i].jawaban[j].name] = false
            }
          }
        }
      }
    }

    const prepareSubmit = async () => {
      // Inject ttd nya
      if (ttdUser.value && !ttdUser.value.isEmpty()) {
        jawabanUser.value.ttd = DataURIToBlob(ttdUser.value.saveSignature('image/png').data)
        testTtd.value = jawabanUser.value.ttd
      }

      // Inject id pendaftar
      jawabanUser.value.id_pendaftar = user.value.id

      // Inject id_mcu
      jawabanUser.value.id_mcu = mcu.value.id_mcu

      // Inject pertanyaan
      jawabanUser.value.pertanyaan = 'fisikk3'

      // Inject token api
      jawabanUser.value.token_api = token.value

      // jadikan form data
      const fd = new FormData()
      const keys = Object.keys(jawabanUser.value)
      for (let i = 0; i < keys.length; i++) {
        // Cuma kirim yg ada isinya aja
        if (jawabanUser.value[keys[i]] !== false && jawabanUser.value[keys[i]] !== '') {
          if (keys[i] === 'ttd') { // kalau ttd ada penanganan khusus
            fd.append(keys[i], jawabanUser.value[keys[i]], 'ttd.png')
          } else {
            fd.append(keys[i], jawabanUser.value[keys[i]])
          }
        }
      }

      // Submit
      try {
        const result = await submitPertanyaan(fd)
        if (result.status) {
          showNotif({
            status: 'success',
            message: 'Anamnesa berhasil disimpan'
          })
        } else {
          showNotif({
            status: 'error',
            message: result.message
          })
        }
      } catch (error) {
        let msg = 'Gagal kirim data'
        if (error.response?.data?.message) {
          msg = error.response.data.message
        }

        showNotif({
          status: 'error',
          message: msg
        })
      }
    }

    onMounted(async () => {
      const result = await getPertanyaan({
        id_pendaftar: user.value.id,
        pertanyaan: 'fisikk3'
      })

      for (let i = 0; i < result.data.length; i++) {
        jawabanUser.value[result.data[i].name] = result.data[i].pertanyaan
        for (let j = 0; j < result.data[i].jawaban.length; j++) {
          let tempJawaban = false
          if (result.data[i].jawaban[j].format === 'text') {
            tempJawaban = ''
          }
          jawabanUser.value[result.data[i].jawaban[j].name] = tempJawaban
        }
      }

      listPertanyaan.value = result.data
    })

    return {
      loading,
      listPertanyaan,
      formatType,
      jawabanUser,
      prepareSubmit,
      updateRadio,
      ttdUser,
      testTtd
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-login {
  border: none;
  padding: 10px 20px;
}

.card-info {
  border-radius: 12px;
  padding: 0;
  overflow: hidden;
}

.form-select {
  border: 1px solid #E2E8F0;
}

.form-control.form-capsule, .form-select.form-capsule {
  border-radius: 12px;
  padding: 8px 14px;
  min-height: 40px;
  background-color: #F7FAFC;
}

.btn-hapus {
  padding: 8px 20px;
  background: #F7FAFC;
  border-radius: 100px;
  padding: 8px 20px;
}
</style>
